module.exports = __webpack_public_path__ + "static/media/dog-staffordshire-bull-terrier.1b126840.png";